import BaseApiRequest from "./BaseApiRequest";
import { GET_DOCUMENT_URL } from "../ApiUrls";
import { METHOD, TOKEN_KEY } from "../Constants";
import axios from "axios";
import { URLS } from "../ApiUrls";

export default class GetDocumentRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_DOCUMENT_URL;

  constructor(memberNumber, docId) {
    super();
    this.url = this.url.replace("%1", memberNumber).replace("%2", docId);
    this.url = `${this.url}?t=${new Date().getTime()}`;
  }

  getMethod = () => this.method;

  getUrl = () => this.url;

  getBody = () => this.body;

  // Override getData to handle binary response
  getData = () => {
    const accessToken = sessionStorage.getItem(TOKEN_KEY);
    const fullUrl = `${this.getUrl()}`;

    return axios({
      method: this.getMethod(),
      url: fullUrl,
      responseType: "blob", // Important: This tells axios to expect binary data
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (!response) {
          throw new Error("response undefined");
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}
